import MobileBottomPanel from '@ui/MobileBottomPanel/component'
import { isDesktop } from 'assets/core/js/common'
import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'

export interface FormDropdownType {
  open: () => void
  close: () => void
}

export default (
  id: string,
  triggerEl: HTMLElement,
  dropdownEl: HTMLElement,
  onOpen?: () => void,
  onClose?: () => void
): FormDropdownType | undefined => {
  if (!triggerEl || !dropdownEl) {
    return
  }

  const el = document.getElementById(id)

  if (!el) {
    return
  }

  const mobileBottomPanelEl = document.getElementById(`${id}-mobilebottompanel`)

  if (!mobileBottomPanelEl) {
    return
  }

  const mobileBottomPanel = MobileBottomPanel(mobileBottomPanelEl, {
    onOpen: () => {
      requestAnimationFrame(() => {
        dropdownEl.removeAttribute('hidden')
      })
    },
    onClose: () => {
      requestAnimationFrame(() => {
        dropdownEl.setAttribute('hidden', 'hidden')
      })
    },
  })

  let isDropdownOpened = false

  const closeDropdownFn = (): void => {
    if (isDropdownOpened) {
      mobileBottomPanel.close()

      isDropdownOpened = false
      isDesktop() && dropdownEl.setAttribute('hidden', 'hidden')
      triggerEl.setAttribute('aria-expanded', 'false')
      document.body.removeEventListener('click', closeDropdownFn)

      onClose?.()
    }
  }

  const openDropdownFn = (): void => {
    if (!isDropdownOpened) {
      mobileBottomPanel.open()

      isDropdownOpened = true
      isDesktop() && dropdownEl.removeAttribute('hidden')
      triggerEl.setAttribute('aria-expanded', 'true')
      requestAnimationFrame(() => {
        document.body.addEventListener('click', (e) => {
          const clickedEl = e.target as HTMLElement

          if (!dropdownEl.contains(clickedEl) && clickedEl !== triggerEl) {
            closeDropdownFn()
          }
        })
      })

      onOpen?.()
    }
  }

  triggerEl.addEventListener('click', openDropdownFn)

  const obj = {
    open: () => openDropdownFn(),
    close: () => closeDropdownFn(),
  }

  ElementPropertiesManager.addProperty<FormDropdownType>(el, 'formDropdown', obj)

  return obj
}
